// extracted by mini-css-extract-plugin
module.exports = {"label":"FieldReview-module__label___26Fxe","value":"FieldReview-module__value___E8-QE"};